module.exports = fox._r("flash/flowplayer.banner-3.2.14.swf", __webpack_public_path__ + "_/_/_/root/flash/flowplayer.banner-3.2.14.swf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/flash/flowplayer.banner-3.2.14.swf
// module id = 670
// module chunks = 4